import React from 'react';
import { useLocation } from 'react-router-dom';

export default function SeoHead() {
  const location = useLocation();
  
  const pageMetadata = {
    '/': {
      title: 'Salong Milepa - Skönhetssalong i Helsingborg',
      description: 'Professionella hudvårdsbehandlingar, massage och skönhetstjänster i Helsingborg.',
    },
    '/behandlingar': {
      title: 'Behandlingar - Salong Milepa Helsingborg', 
      description: 'Upptäck våra behandlingar: ansiktsbehandlingar, massage, plasma pen, microneedling och mer.',
    },
    '/personal': {
      title: 'Vårt Team - Certifierade hudterapeuter | Salong Milepa',
      description: 'Möt vårt erfarna team av auktoriserade hudterapeuter och massörer.',
    },
    '/bilder': {
      title: 'Galleri - Behandlingsresultat | Salong Milepa',
      description: 'Se resultat från våra behandlingar. Galleri med bilder från Salong Milepa i Helsingborg.',
    },
    '/om-oss': {
      title: 'Om Oss - Salong Milepas Historia & Värderingar',
      description: 'Läs om Salong Milepas historia sedan 2014. Vår passion för skönhet och commitment till kvalitet.',
    }
  };

  const meta = pageMetadata[location.pathname] || {
    title: 'Sidan hittades inte - Salong Milepa',
    description: 'Sidan du letar efter kunde inte hittas. Besök vår startsida för att hitta vad du söker.'
  };

  React.useEffect(() => {
    document.title = meta.title;
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = meta.description;

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = `https://salongmilepa.se${location.pathname}`;

  }, [location.pathname, meta]);

  return null;
}